const routeNames = {
  Appointment: 'appointment',
  AppointmentConfirmation: 'appointment_confirmation',
  AppointmentContact: 'appointment_contact',
  AppointmentCreateAccount: 'appointment_create_account',
  AppointmentProperty: 'appointment_property',
  AppointmentSchedule: 'appointment_schedule',
  AppointmentServices: 'appointment_services',
  AppointmentSignIn: 'appointment_sign_in',
  AppointmentSummary: 'appointment_summary',
  CompanyNotFound: 'company_not_found',
  NotFound: 'not_found',
  Home: 'home',
};

export default routeNames;
